jQuery( document ).ready( function() {
	let postionTerms = [];
	let locationTerms = [];
	let engagementTerms = [];
	let departmentTerms = [];
	function nofoundMessage() {
		jQuery( '.job-offers' ).each( function() {
			if ( jQuery( this ).children().length < 1 ) {
				jQuery( this ).parents( '.job-teaser-block' ).remove();
			}
		} );
		if ( jQuery( '.job-teaser-results' ).children( ':not(.active-filters)' ).length < 1 ) {
			const filterHTML = jQuery( '.job-teaser-results' ).find( '.active-filters' ).html();
			jQuery( '.job-teaser-results' ).html( '<div class="active-filters">' + filterHTML + '</div><p>No jobs found Please try different search filter.</p>' );
		}
		jQuery( '.job-state-filter' ).each( function() {
			if ( jQuery( '.job-checkbox-2[data-state="' + jQuery( this ).attr( 'data-id' ) + '"]' ).length === 0 ) {
				jQuery( this ).remove();
			}
		} );
	}

	nofoundMessage();
	jQuery( '.js-buttons__view--grid, .js-buttons__view--list' ).on( 'click', function() {
		jQuery( '.loader-container' ).show();
		setTimeout( function() {
			jQuery( '.loader-container' ).hide();
		}, 500 );
	} );
	jQuery( '.job-clear-filter' ).on( 'click', function() {
		const type = jQuery( this ).attr( 'data-clear' );
		if ( jQuery( window ).width() > 1179 ) {
			jQuery( this ).hide();
		}
		if ( type === 'position' ) {
			postionTerms = [];
			jQuery( '.job-checkbox' ).each( function() {
				jQuery( this ).find( '.position-checkbox' ).prop( 'checked', false );
			} );
			updateThePermalink();
			sendAjaxRequest();
		} else if ( type === 'location' ) {
			locationTerms = [];
			jQuery( '.job-checkbox' ).each( function() {
				jQuery( this ).find( '.location-checkbox' ).prop( 'checked', false );
			} );
			updateThePermalink();
			sendAjaxRequest();
		} else if ( type === 'engagement' ) {
			engagementTerms = [];
			jQuery( '.job-checkbox' ).each( function() {
				jQuery( this ).find( '.engagement-checkbox' ).prop( 'checked', false );
			} );
			updateThePermalink();
			sendAjaxRequest();
		} else {
			jQuery( '.job-checkbox' ).each( function() {
				jQuery( this ).find( 'input[type="checkbox"]' ).prop( 'checked', false );
			} );
			const reseturl = location.href.split( '?' )[ 0 ];
			window.history.pushState( 'object', document.title, reseturl );
			departmentTerms = [];
			engagementTerms = [];
			locationTerms = [];
			postionTerms = [];
			sendAjaxRequest();
		}
		// updateThePermalink();
	} );
	jQuery( document ).on( 'click', '.remove-item-js', function() {
		const type = jQuery( this ).attr( 'data-type' );
		const value = jQuery( this ).attr( 'data-value' );
		jQuery( '.' + type + '-checkbox[value="' + value + '"]' ).prop( 'checked', false ).trigger( 'change' );
		jQuery( this ).remove();
	} );

	function handleGridView( ajaxCall = false ) {
		function wrap3( $container ) {
			$container.each( function() {
				const outerBoxes = jQuery( this ).find( '.outer-box' );
				let currentIndex = 0;

				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 3;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice( currentIndex, endIndex );
					elementsToWrap.wrapAll( '<div class="row"></div>' );
					currentIndex = endIndex;
				}
			} );
		}

		function wrap2( $container ) {
			$container.each( function() {
				const outerBoxes = jQuery( this ).find( '.outer-box' );
				let currentIndex = 0;

				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 2;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice( currentIndex, endIndex );
					elementsToWrap.wrapAll( '<div class="row"></div>' );
					currentIndex = endIndex;
				}
			} );
		}

		jQuery( '.loader-container' ).show();
		if ( ! ajaxCall ) {
			jQuery( '.hide-filter-button' ).on( 'click', function() {
				const $container = jQuery( '.job-offers' );
				// Unwrap existing rows
				$container.find( '.row' ).contents().unwrap();
				// Wrap items into rows of three
				wrap3( $container );
			} );
		}

		if ( ! ajaxCall ) {
			jQuery( '.js-open-button' ).on( 'click', function() {
				const $button = jQuery( this );
				const $inner = $button.find( '.js-button-filter-text' );
				const innerText = $inner.text().trim();
				jQuery( '.job-results-view' ).toggleClass( 'is-filter-showing' );
				jQuery( this ).toggleClass( 'hide-filter-button' );
				jQuery( 'body' ).addClass( 'header-white-conversion' );
				jQuery( '.menu-btn' ).addClass( 'mobile-popup-close' );

				if ( jQuery( window ).width() > 1003 ) {
					if ( innerText === 'Hide Filters' ) {
						$inner.text( 'Show Filters' );
						// Apply wrap3 function
						const $container = jQuery( '.job-offers' );
						// Unwrap existing rows
						$container.find( '.row' ).contents().unwrap();
						// Wrap items into rows of three
						wrap3( $container );
					} else {
						$inner.text( 'Hide Filters' );
						// Apply wrap2 function
						const $container = jQuery( '.job-offers' );
						// Unwrap existing rows
						$container.find( '.row' ).contents().unwrap();
						// Wrap items into rows of two
						wrap2( $container );
					}
				}
			} );
		}
		if ( ajaxCall ) {
			wrap2( jQuery( '.job-offers' ) );
		} else {
			wrap2( jQuery( '.job-offers' ) );
		}
		setTimeout( function() {
			jQuery( '.loader-container' ).hide();
		}, 500 );
	}
	handleGridView();
	jQuery( '.loader-container' ).show();
	const onLoadFoundPosts = jQuery( '.found-posts' ).attr( 'found-posts' );
	jQuery( '.position-checkbox:checked' ).each( function() {
		postionTerms.push( jQuery( this ).val() );
	} );
	jQuery( '.location-checkbox:checked' ).each( function() {
		locationTerms.push( jQuery( this ).val() );
	} );
	jQuery( '.engagement-checkbox:checked' ).each( function() {
		engagementTerms.push( jQuery( this ).val() );
	} );
	jQuery( '.department-checkbox:checked' ).each( function() {
		departmentTerms.push( jQuery( this ).val() );
	} );
	// updateThePermalink();
	jQuery( '.loader-container' ).hide();

	jQuery( '.found-post-container' ).text( onLoadFoundPosts );
	function updateThePermalink() {
		if ( history.pushState ) {
			const oldUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			let baseUrl = oldUrl;
			const queryParams = [];

			if ( postionTerms !== undefined && postionTerms.length > 0 ) {
				const encodedTerms = postionTerms.map( ( term ) => encodeURIComponent( term ) );
				const joinedTerms = encodedTerms.join( ',' );
				queryParams.push( `positions=${ encodeURI( joinedTerms ) }` );
			}
			if ( locationTerms !== undefined && locationTerms.length > 0 ) {
				const encodedLocationTerms = locationTerms.map( ( term ) => encodeURIComponent( term ) );
				const joinedLocationTerms = encodedLocationTerms.join( ',' );
				queryParams.push( `location=${ encodeURI( joinedLocationTerms ) }` );
			}
			if ( engagementTerms !== undefined && engagementTerms.length > 0 ) {
				const encodedTerms = engagementTerms.map( ( term ) => encodeURIComponent( term ) );
				const joinedTerms = encodedTerms.join( ',' );
				queryParams.push( `engagement=${ encodeURI( joinedTerms ) }` );
			}
			if ( departmentTerms !== undefined && departmentTerms.length > 0 ) {
				const encodedTerms = departmentTerms.map( ( term ) => encodeURIComponent( term ) );
				const joinedTerms = encodedTerms.join( ',' );
				queryParams.push( `department=${ encodeURI( joinedTerms ) }` );
			}
			// Construct the query string
			if ( queryParams.length > 0 ) {
				baseUrl += '?' + queryParams.join( '&' );
			}
			window.history.pushState( { path: baseUrl }, '', baseUrl );
		}
	}
	function handleButtonClick() {
		const postsCounter = 0;
		const remaingPosts = 0;
		const clickCount = 0;
		let clickedCategory;
		jQuery( '.js-open-button' ).click( function( event ) {
			jQuery( '.loader-container' ).show();
			jQuery( '.caregivers.outer-box' ).each( function() {
				// Check if the current element's computed display is not 'none'
				if ( jQuery( this ).css( 'display' ) !== 'none' ) {
					// Add a class to the current element
					jQuery( this ).parent().addClass( 'has-border' );
					console.log( "Element with class 'caregivers outer-box' has display set to something other than 'none' and now has the class 'has-border'" );
				} else {
					console.log( "Element with class 'caregivers outer-box' has display set to 'none'" );
				}
			} );
			setTimeout( function() {
				jQuery( '.loader-container' ).hide();
			}, 500 );
		} );

		jQuery( '.ajax-loadmore-click' ).click( function( event ) {
			event.preventDefault();
			// if ( jQuery( this ).attr( 'clicked-category' ) !== clickedCategory ) {
			// 	clickCount = 0;
			// 	postsCounter = 0;
			// }

			// clickCount++;

			// const foundPosts = parseInt( jQuery( this ).attr( 'found-posts' ) );
			// clickedCategory = jQuery( this ).attr( 'clicked-category' );
			// if ( foundPosts > 4 ) {
			// 	if ( clickCount == 1 ) {
			// 		remaingPosts = foundPosts;
			// 		jQuery( '.' + clickedCategory ).slice( 0, 11 ).show();
			// 		jQuery( '.' + clickedCategory ).slice( 0, 11 ).parent().addClass( 'has-border' );

			// 		postsCounter = postsCounter + 11;
			// 		remaingPosts = remaingPosts - 11;
			// 	} else {
			// 		remaingPosts = remaingPosts - 6;
			// 		postsCounter = postsCounter + 6;
			// 		jQuery( '.' + clickedCategory ).slice( 6, postsCounter ).show();
			// 		jQuery( '.' + clickedCategory ).slice( 6, postsCounter ).parent().addClass( 'has-border' );
			// 	}
			// }
			// jQuery( this ).find( '.button-number' ).text( remaingPosts );
			// if ( postsCounter >= foundPosts ) {
			// 	jQuery( this ).parent().hide();
			// }

			clickedCategory = jQuery( this ).attr( 'clicked-category' );
			jQuery( '.' + clickedCategory ).parent().addClass( 'has-border' );
			jQuery( '.' + clickedCategory ).show();
			jQuery( this ).parent().hide();
			// console.log( postsCounter );
			// console.log( 'Remaing Posts: ' + remaingPosts );
			// console.log( 'Clicked Category: ' + clickedCategory );
		} );
	}

	// Call the function to initialize the click event handling
	handleButtonClick();
	jQuery( '.position-checkbox' ).on( 'change', function() {
		postionTerms = [];
		jQuery( '.position-checkbox:checked' ).each( function() {
			postionTerms.push( jQuery( this ).val() );
		} );
		jQuery( '.job-clear-filter' ).show();
		sendAjaxRequest();
		updateThePermalink();
		// console.log( postionTerms );
	} );
	jQuery( '.location-checkbox' ).on( 'change', function() {
		locationTerms = [];
		jQuery( '.location-checkbox:checked' ).each( function() {
			locationTerms.push( jQuery( this ).val() );
		} );
		jQuery( '.job-clear-filter' ).show();
		sendAjaxRequest();
		updateThePermalink();

		// console.log( locationTerms );
	} );
	jQuery( '.engagement-checkbox' ).on( 'change', function() {
		engagementTerms = [];
		jQuery( '.engagement-checkbox:checked' ).each( function() {
			engagementTerms.push( jQuery( this ).val() );
		} );
		jQuery( '.job-clear-filter' ).show();
		sendAjaxRequest();
		updateThePermalink();

		// console.log( engagementTerms );
	} );
	jQuery( document ).on( 'click', '.job-state-filter', function() {
		const slug = jQuery( this ).attr( 'data-id' );
		jQuery( '.job-checkbox-2' ).hide();
		jQuery( '.job-checkbox-2[data-state="' + slug + '"]' ).show();
	} );
	jQuery( '.department-checkbox' ).on( 'change', function() {
		departmentTerms = [];
		jQuery( '.department-checkbox:checked' ).each( function() {
			departmentTerms.push( jQuery( this ).val() );
		} );
		jQuery( '.job-clear-filter' ).show();
		sendAjaxRequest();
		updateThePermalink();

		// console.log( departmentTerms );
	} );
	changePageMeta();
	function sendAjaxRequest() {
		jQuery( '.loader-container' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'job_filter',
				nonce: localVars.nonce,
				postionTerms,
				locationTerms,
				engagementTerms,
				departmentTerms,

			},
			success( response ) {
				if ( response ) {
					jQuery( '#jobs-container' ).html( response.html );
					jQuery( '#van-pagination-container' ).html( response.pagination );
					jQuery( '#results-number' ).text( response.total_no_of_posts );
					jQuery( '.found-post-container' ).text( response.found_posts );
					jQuery( '.loader-container' ).hide();
					// const locations = response.locations;
					// jQuery( '.location-checkbox-ctn' ).find( '.job-checkbox-2' ).hide();
					// for ( const key in locations ) {
					// 	const element = locations[ key ];
					// 	jQuery( '.location-checkbox-ctn' ).find( '.job-checkbox-2[data-id="' + element + '"]' ).show();
					// }
					changePageMeta();
					handleButtonClick();
					handleGridView( true );
					nofoundMessage();
					if ( jQuery( '.section-head' ).length === 1 ) {
						jQuery( '.section-head' ).html( '<h1 class="heading-3">' + jQuery( '.section-head' ).find( '.heading-3' ).text() + '</h1>' );
					}
				}
			},
			error() {
				const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
				jQuery( '#jobs-container' ).html( htmlTag );
				jQuery( '.loader-container' ).hide();
				jQuery( '.found-post-container' ).text( 0 );
				nofoundMessage();
			},
		} );
	}
	const locationGET = getParameterByName( 'location' );
	if ( locationGET ) {
		const locationState = jQuery( '.location-checkbox[value="' + locationGET + '"]' ).parent().attr( 'data-state' );
		// alert( locationState, locationGET );
		jQuery( '.job-state-filter' ).find( '.location-state-checkbox[value="' + locationState + '"]' ).prop( 'checked', true ).parent().trigger( 'click' );
	}
	function changePageMeta( ) {
		console.log( locationTerms );
		const metaDescription = jQuery( 'meta[name="description"]' );
		const metaTitleTag = jQuery( 'title' );
		// console.log( locationTerms, engagementTerms, postionTerms );
		// console.log( locationTerms.length, engagementTerms.length, postionTerms.length );
		// console.log( locationTerms.length === 1 && engagementTerms.length === 0 && postionTerms.length === 0 );
		let title = '';
		if ( locationTerms.length > 0 && engagementTerms.length === 0 && postionTerms.length === 0 ) {
			if ( locationTerms[ 0 ] === 'waco-tx' ) {
				title = 'Waco, TX';
			} else if ( locationTerms[ 0 ] === 'houston-tx' ) {
				title = 'Houston, TX';
			} else if ( locationTerms[ 0 ] === 'remote' ) {
				title = 'Remote';
			} else if ( locationTerms[ 0 ] === 'general' ) {
				title = 'General';
			} else {
				title = jQuery( '.job-checkbox-2[data-id="' + locationTerms[ 0 ] + '"]' ).find( 'label' ).text();
			}
			// console.log( locationTerms[ 0 ], jQuery( '.job-checkbox-2[data-id="' + locationTerms[ 0 ] + '"]' ) );
			const metaTitle = 'Senior At-Home Care Services in ' + title;
			const content = 'Cornerstone Caregiving is a senior in-home care assistance service in ' + title + ' that allows your loved ones to stay where they feel most comfortable: at their home.';
			// console.log( content );
			// Check if the meta tag exists
			if ( metaDescription.length > 0 ) {
				// Change the content of the meta tag
				metaDescription.attr( 'content', content );
			} else {
				// If the meta tag doesn't exist, create it and append it to the head
				jQuery( '<meta/>', {
					name: 'description',
					content,
				} ).appendTo( 'head' );
			}
			if ( metaTitleTag.length > 0 ) {
				// Change the content of the meta tag
				metaTitleTag.text( metaTitle );
			}
		}
	}
	function getParameterByName( name, url = window.location.href ) {
		name = name.replace( /[\[\]]/g, '\\$&' );
		const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' ),
			results = regex.exec( url );
		if ( ! results ) {
			return null;
		}
		if ( ! results[ 2 ] ) {
			return '';
		}
		return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
	}
} );
